export default {"src":"/_next/static/image/public/images/cancel_order.35bd96e3fe9199fd5987b906aa3591d7.svg","height":150,"width":138};